module.exports = __webpack_public_path__ + "img/img2_04.61283fef.png";